"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsMainSidebar = void 0;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _reactProSidebar = require("react-pro-sidebar");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsMainSidebar component represents a sidebar navigation menu.
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.children - The content of the sidebar. Should contain DmsMainSidebar.Item components.
 * @param {boolean} props.collapsed - Whether the sidebar is collapsed or expanded.
 * @returns {JSX.Element} DmsMainSidebar component.
 * 
 * @example
 * <DmsMainSidebar collapsed={collapsed}>
 *   <DmsMainSidebar.Item>
 *     <DmsMainSidebarOption
 *       title={intl.get("Home").d("Home")}
 *       icon={<HomeIcon />}
 *       route={ROUTES.Home}
 *     />
 *   </DmsMainSidebar.Item>
 *   {components}
 *   {pages}
 * </DmsMainSidebar>
 */
const DmsMainSidebar = _ref => {
  let {
    children,
    collapsed
  } = _ref;
  const theme = (0, _material.useTheme)();
  return /*#__PURE__*/_react.default.createElement(_reactProSidebar.Sidebar, {
    style: {
      height: '100%',
      top: 'auto',
      position: 'static'
    },
    breakPoint: "md",
    backgroundColor: theme.palette.sidebar.main,
    collapsed: collapsed
  }, _react.default.Children.map(children, (child, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactProSidebar.Menu, {
    collapsed: collapsed,
    menuItemStyles: {
      button: _ref2 => {
        let {
          active
        } = _ref2;
        return {
          backgroundColor: active ? theme.palette.sidebar.active : theme.palette.sidebar.main,
          color: theme.palette.sidebar.text,
          '&:hover': {
            backgroundColor: theme.palette.sidebar.active,
            color: theme.palette.secondary.text
          }
        };
      }
    }
  }, /*#__PURE__*/_react.default.cloneElement(child, {
    collapsed
  })), index < children.length - 1 && /*#__PURE__*/_react.default.createElement(_material.Divider, {
    sx: {
      backgroundColor: theme.palette.sidebar.divider
    }
  }))));
};

/**
 * DmsMainSidebar.Item component represents an item in the sidebar menu.
 * @param {Object} props - Component props.
 * @param {React.ReactNode} props.children - The content of the sidebar item.
 * @returns {JSX.Element} DmsMainSidebar.Item component.
 */
exports.DmsMainSidebar = DmsMainSidebar;
DmsMainSidebar.Item = _ref3 => {
  let {
    children
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _react.default.Children.map(children, child => child));
};